import React from "react";
import { Field } from "react-final-form";
import { SelectAdapter } from "@soqs/common";

const SelectComponent = (props) => {
  let { required = false, optionsloading = false, label, ...rest } = props;

  const isRequired = (x) => {
    return !required || x ? undefined : `${label} must be selected`;
  };

  return (
    <Field
      required={required}
      label={label}
      fullWidth
      validate={isRequired}
      component={SelectAdapter}
      loading={optionsloading}
      subscription={{ touched: true, value: true, error: true }}
      {...rest}
    />
  );
};

export default SelectComponent;
